import React, { useEffect, useState } from "react";

import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { ICONS } from "config/assetPaths";
import CustomButton from "Components/Custom/CustomButton";
import { useAppSelector } from "Components/Hooks/hooks";

interface TemplatePreviewModalProps {
  showModal: boolean;
  toggle: () => void;
  onContinue: (template: string) => void;
  template: string;
  loading: boolean;
}

const TemplatePreviewModal: React.FC<TemplatePreviewModalProps> = ({
  showModal,
  toggle,
  onContinue,
  template,
  loading,
}) => {
  console.log("props", template);
  const [selectedTemplate, setSelectedTemplate] = useState<string>(template);

  useEffect(() => {
    console.log("selectedTemplate", selectedTemplate);
  }, [selectedTemplate]);

  const typeOfTemplate = Object.keys(
    useAppSelector(
      (stat) => stat.config.configData?.document_setting.templates,
    ) ?? {},
  );

  // ✅ SYNC when modal opens OR parent template changes
  useEffect(() => {
    if (showModal) {
      setSelectedTemplate(template);
    }
  }, [showModal, template]);

  const templateArray =
    typeOfTemplate.length === 0
      ? ["classic", "modern", "elegant"]
      : typeOfTemplate;

  return (
    <Modal
      isOpen={showModal}
      toggle={toggle}
      centered
      size="lg"
      autoFocus={false} // ✅ IMPORTANT (prevents first-item focus bug)
    >
      <ModalHeader toggle={toggle}>Templates</ModalHeader>

      <ModalBody>
        <Row className="gap-3 justify-content-center">
          {templateArray.map((img, index) => (
            <Col
              key={img}
              className="position-relative p-0"
              onClick={() => setSelectedTemplate(img)}
              style={{ cursor: "pointer" }}
            >
              <img
                alt={`template-${index}`}
                src={ICONS[img as keyof typeof ICONS]}
                className={`w-100 rounded-3 border ${
                  selectedTemplate === img
                    ? "border-primary border-3"
                    : "border-border border-2"
                }`}
              />

              {selectedTemplate === img && (
                <div className="position-absolute top-50 start-50 translate-middle">
                  <i className="ri-check-fill text-primary fs-1" />
                </div>
              )}
            </Col>
          ))}
        </Row>
      </ModalBody>

      <ModalFooter>
        <CustomButton
          text="Continue"
          onClick={() => onContinue(selectedTemplate)}
          loading={loading}
        />
      </ModalFooter>
    </Modal>
  );
};

export default TemplatePreviewModal;
